<script setup lang="ts"></script>

<template>
  <icon name="lucide:more-vertical" />
</template>

<style scoped></style>
